import { inject, injectable } from 'inversify';
import { makeAutoObservable } from 'mobx';
import { IQrCodeInvoicesWidgetViewModel } from '@shared/types/mobx/widgets/OsiInvoicesQrCode';
import api from '@app/api';
import { notifications } from '@shared/utils/notifications';
import logger from 'js-logger';
import { type OsiService, OsiServiceIdentifier } from '@shared/types/mobx/services/osi';
import { MIME, downloadBase64 } from '@shared/utils/download';

@injectable()
export class QrCodeInvoicesWidgetViewModel implements IQrCodeInvoicesWidgetViewModel {
  qrCodeInfoVideoLink = 'https://www.youtube.com/shorts/pAgT4YRZQzQ';

  isLoading = false;

  pdf: any = null;

  constructor(@inject(OsiServiceIdentifier) private osiModule: OsiService) {
    makeAutoObservable(this);
    this.loadQrCodePdf();
  }

  get tgLink() {
    return `https://t.me/OSISubscriptionBot?start=${this.osiModule.osiId}`;
  }

  printQrCode = async () => {
    const blob = new Blob([Uint8Array.from(atob(this.pdf), (c) => c.charCodeAt(0))], { type: 'application/pdf' });
    window.open(URL.createObjectURL(blob));
  };

  downloadQrCode = async () => {
    // iOS/WebKit: data:-URL не скачивается по атрибуту download — переведено на blob: через downloadBase64
    downloadBase64(this.pdf, MIME.PDF, 'QRCode.pdf');
  };

  private loadQrCodePdf = async () => {
    try {
      if (!this.osiModule.osiId) throw new Error('osiId is undefined');

      this.isLoading = true;
      // @ts-expect-error api not typed
      const { pdfBase64 } = await api.getQRInvoicePDF(this.osiModule.osiId);
      this.pdf = pdfBase64;
    } catch (e) {
      logger.error(e);
      notifications.error('Ошибка');
    } finally {
      this.isLoading = false;
    }
  };
}
